export default __webpack_public_path__ + "static/media/rs.06b5537e.svg";